'use es6';

export default function createTicketer() {
  const tickets = {};
  return {
    getTicket(key = 'default') {
      if (typeof tickets[key] === 'undefined') {
        tickets[key] = {
          lastTicket: 0,
          lastHandledTicket: -1
        };
      }
      return {
        key,
        value: tickets[key].lastTicket++
      };
    },
    shouldHandleTicket(ticket) {
      const keyState = tickets[ticket.key];
      if (ticket.value > keyState.lastHandledTicket) {
        keyState.lastHandledTicket = ticket.value;
        return true;
      }
      return false;
    }
  };
}